import React from 'react'
import './SearchPageBodyContentHeader.css'

function SearchPageBodyContentHeader() {
    return (
        <div className="spbch">
            
        </div>
    )
}

export default SearchPageBodyContentHeader
